import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getPerfiles = query =>
	fetch.get(
		`/users-permissions/roles${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getPerfil = ({ id, query }) =>
	fetch.get(
		`/users-permissions/roles/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addPerfil = data => fetch.post('/users-permissions/roles', data);
export const updatePerfil = ({ id, ...data }) =>
	fetch.put(`/users-permissions/roles/${id}`, data);
export const deletePerfil = id =>
	fetch.delete(`/users-permissions/roles/${id}`);

// RTK Query
export const perfilesApi = createApi({
	reducerPath: 'perfilesApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getPerfiles: build.query({
			query: query => {
				return {
					url: `/users-permissions/roles${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.roles,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'Perfiles', id })),
							{ type: 'Perfiles', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Perfiles', id: 'LIST' }],
		}),
		getPerfil: build.query({
			query: ({ id, query }) => {
				return {
					url: `/users-permissions/roles/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Perfiles', id }],
		}),
		addPerfil: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/users-permissions/roles`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Perfil agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar perfil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Perfiles', id: 'LIST' }],
		}),
		updatePerfil: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/users-permissions/roles/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Perfil actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar perfil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'Perfiles', id }],
		}),
		deletePerfil: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/users-permissions/roles/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Perfil eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar perfil');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Perfiles', id }],
		}),
	}),
});

export const {
	useGetPerfilesQuery,
	useGetPerfilQuery,
	useAddPerfilMutation,
	useUpdatePerfilMutation,
	useDeletePerfilMutation,
} = perfilesApi;
